// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as Belt_Id from "rescript/lib/es6/belt_Id.js";
import * as Belt_Map from "rescript/lib/es6/belt_Map.js";

function Make($star) {
  var Id = {};
  var toString = function (x) {
    return String(x);
  };
  var eq = function (x1, x2) {
    return x1 === x2;
  };
  var cmp = Caml.caml_int_compare;
  var Comparable = Belt_Id.MakeComparable({
        cmp: cmp
      });
  var make = function (param) {
    return Belt_Map.make(Comparable);
  };
  var $$Map = {
    make: make
  };
  return {
          Id: Id,
          toString: toString,
          eq: eq,
          cmp: cmp,
          Comparable: Comparable,
          $$Map: $$Map
        };
}

export {
  Make ,
  
}
/* No side effect */
